define('OutSystems/ClientRuntime/modules/Database/Common/ValueConstraintValidation',["require", "exports", "../../../Exceptions", "../DBDataType", "../TableInfoUtils"], function (require, exports, Exceptions_1, DBDataType_1, TableInfoUtils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.validateValueForCreateOrUpdate = exports.validateRecordForCreateOrUpdate = void 0;
    function validateRecordForCreateOrUpdate(info, record, operation) {
        for (var _i = 0, _a = record.getAttributes(); _i < _a.length; _i++) {
            var attr = _a[_i];
            validateValueForCreateOrUpdate(record[attr.attrName], TableInfoUtils.getMatchingColumn(info, attr), operation + " '" + info.tableName + "." + attr.name + "'");
        }
    }
    exports.validateRecordForCreateOrUpdate = validateRecordForCreateOrUpdate;
    function validateValueForCreateOrUpdate(value, columnInfo, operation) {
        if (columnInfo.type === DBDataType_1.default.TEXT) {
            if (!value) {
                return;
            }
            var attrValue = value;
            var lengthDiff = attrValue.length - columnInfo.length;
            if (lengthDiff > 0) {
                throw new Exceptions_1.Exceptions.DataBaseException("", "Unable to " + operation + " because it exceeds the maximum allowed length by " + lengthDiff + " characters.");
            }
        }
        else if (columnInfo.type === DBDataType_1.default.DECIMAL) {
            var attrValue = value;
            var lengthDiff = attrValue.trunc().abs().toString().length - (columnInfo.length - columnInfo.decimals);
            if (lengthDiff > 0) {
                throw new Exceptions_1.Exceptions.DataBaseException("", "Unable to " + operation + " because it exceeds the maximum allowed length by " + lengthDiff + " characters.");
            }
        }
    }
    exports.validateValueForCreateOrUpdate = validateValueForCreateOrUpdate;
});
//# sourceMappingURL=ValueConstraintValidation.js.map;
